<template>
  <div class="match-invite-page page">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header @chooseTab="getTab" :currentIndex="currentIndex"></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate">
        <div class="label">我的位置：</div>
        <breadcrumb />
      </section>

      <section class="content w">
        <div class="c-left">
          <h1 class="article-title">{{ article.articleName || '' }}</h1>
          <div class="article-author">
            <span v-if="article.releaseTime">{{
              '发布时间： ' + article?.releaseTime
            }}</span>
          </div>
          <el-divider />
          <div class="article-content" v-html="article.articleContent"></div>
        </div>
        <div class="c-right">
          <div class="recommend">
            <!-- <div class="listBlock" v-if="reNewsList.length">
              <div class="list-header">
                <div class="list-title">推荐阅读</div>
              </div>
              <div class="list-content">
                <div class="list-item" v-for="(item, index) in reNewsList" :key="index" @click="toReDetail(item)">
                  <div class="item-title">
                    {{ item.articleName }}
                  </div>
                </div>
              </div>
            </div> -->
            <div class="listBlock">
              <div class="code-content">
                <img
                  class="img"
                  :src="
                    $globalHeader.fileUrl + '/static/fjtwfw/office_qrcode.png'
                  "
                  alt=""
                />
                <p class="code-text">
                  <strong>福建通文服务微信公众号</strong>
                </p>
                <img
                  class="img"
                  :src="$globalHeader.fileUrl + '/static/fjtwfw/qrcode.png'"
                  alt=""
                />
                <p class="code-text">
                  <strong>福建通文服务咨询微信二维码</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from '@/components/common/pageTop.vue'
import Header from '@/components/common/header.vue'
import Footer from '@/components/common/footer.vue'
import Breadcrumb from '@/components/common/breadcrumb'

import { getArticleById, getSideArticle } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
export default {
  name: 'Policy',
  components: { pageTop, Header, Footer, Breadcrumb },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: {
        releaseTime: ''
      },
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      },
      sideArticle: {
        before: null,
        after: null
      },
      id: null,
      currentIndex: 2
    }
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]
        if (this.tabList.list) {
          //拿下一级
          this.currentCategory = this.tabList.list[0]
        } else {
          this.currentCategory = this.tabList[0]
        }

        console.log('this.tabList', this.tabList)
      })
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.article = res.data
      })
    },
    // 查询上一篇文章和下一篇文章
    queryideArticle(id) {
      let params = {
        id: id,
        categoryCode: this.categoryId
      }
      getSideArticle(params).then((res) => {
        if (!res.data) return
        this.sideArticle = res.data
      })
    },
    handleSideArticle(id) {
      if (id == null) {
        return
      }
      let url =
        '/train/articleDetail?categoryId=' +
        this.categoryId +
        '&linkType=' +
        this.pageType +
        '&tabcode=' +
        this.tabcode +
        '&seccode=' +
        this.seccode +
        '&id=' +
        id
      window.location.href = url
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl)
        url = '/train/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/train/singleImage' + url
      }
      if (item.linkType == 3) {
        console.log(item.linkType)
      }
      if (item.linkType == 4) {
        console.log(item.linkType)
      }
      if (item.linkType == 5) {
        console.log(item.linkType)
      }
      this.$router.push({
        path: url
      })
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.id = this.$route.query?.id
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    if (this.tabcode == 103) {
      this.currentIndex = 2
    }
    if (this.tabcode == 104) {
      this.currentIndex = 3
    }
    this.seccode = this.$route.query?.seccode
    this.fetchData()
    this.getArticleData(this.id)
    this.queryideArticle(this.id)
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-breadcrumb__inner.is-link,
::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}
::v-deep .el-breadcrumb__separator,
::v-deep .el-breadcrumb__separator:hover {
  color: #fff;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #fff;
}

.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;
    margin-top: 60px;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .c-title {
      font-size: 30px;
      padding-left: 17px;
      border-left: 3px solid rgb(12, 108, 228);
      font-weight: 700;
    }
    .english-name {
      color: rgb(153, 153, 153);
      margin-left: 10px;
    }

    .article-name {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 20px auto;

      .title-wrap {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 18px;

        .side-wrap {
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          width: 400px;
          margin: 0px 10px;
        }
      }

      .left:hover,
      .right:hover {
        color: #409eff !important;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 30px;
      margin-bottom: 100px;

      .c-top {
        display: flex;
        justify-content: center;
      }

      .c-left {
        flex: 1;
        margin-right: 15px;
        background-color: #fff;
        padding: 60px 30px;
        box-shadow: 0px 2px 2px #edeef0;
        min-height: 500px;

        padding-bottom: 70px;
        .article-title {
          margin: 0;
          text-align: center;
          font-weight: 700;
          font-style: normal;
          font-size: 34px;
          color: #000000;
          line-height: 1.35;
        }
        .article-author {
          text-align: center;
          color: #666666;
          font-weight: 400;
          font-style: normal;
          margin-top: 30px;
          font-size: 14px;
        }

        .article-content {
          font-size: 16px !important;
          line-height: 2 !important;
          min-height: 640px;
        }
      }
      .c-right {
        flex-shrink: 0;
        width: 320px;

        .recommend {
          margin-bottom: 15px;
          background-color: #fff;
        }
        .listBlock {
          padding: 20px;
          display: flex;
          flex-direction: column;

          .list-header {
            display: flex;
            font-size: 18px;
            font-weight: bold;
            padding: 10px 0;
            border-bottom: 1px dashed #cccccc;
            color: #666;
            .list-title {
              color: #005495;
              padding-right: 20px;
              position: relative;
            }
            .list-title::after {
              content: '';
              position: absolute;
              top: 20%; /* 让竖线居中 */
              bottom: 20%;
              height: 60%;
              right: -5px; /* 调整竖线位置 */
              width: 1px;
              background-color: #b3b3b3;
            }
          }
          .list-header:hover {
            color: #087cd6;
            cursor: pointer;
          }
          .code-content {
            text-align: center;
            padding: 10px 0;
            border-bottom: 1px dashed #cccccc;
            .img {
              height: 133px;
              width: 133px;
            }
            .code-text {
              padding: 2px 0 30px;
            }
          }
          .list-content {
            padding: 10px 0;
            border-bottom: 1px dashed #cccccc;
          }
          .list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 6px 0;
            .item-title {
              flex: 1;
              display: -webkit-box;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
            }
            .item-title:hover {
              color: #087cd6;
              cursor: pointer;
            }
            .item-time {
              margin-left: 20px;
              color: #999;
            }
          }
          .list-item::before {
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: black;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>
